import { Flex } from "antd";
import { FC } from "react";
import { CustomerPageFilterProps } from "../consumer/CustomerPageWrapper";
import "./index.less";

interface FilterProps extends CustomerPageFilterProps {
  isActive: boolean;
}

export const Filter: FC<FilterProps> = ({ name, onClick, isActive }) => {
  return (
    <Flex className="filter" onClick={onClick}>
      <p className={`filter-name ${isActive && "filter-name--active"}`}>{name}</p>
    </Flex>
  );
};
